const setStatusTag = (value) =>
  document
    .querySelector('meta[name="prerender-status-code"]')
    .setAttribute('content', value)

export { setStatusTag }
